export const reportSalesCumulativeGlobalTypes = {
  SET_SALES_CUMULATIVE_GLOBAL_FILTERS: 'SET_SALES_CUMULATIVE_GLOBAL_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
